
interface TextProps {
  text?: string;
}

export default function Text({ text }: TextProps) {
  return (
    <div className="w-full flex items-start justify-start gap-[8px]">
      <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[24px]">
        {text?.split('\n')?.map((line, index) => (
          <span key={index}>
            {line}
            {index < (text?.split('\n').length || 0) - 1 && <br />}
          </span>
        ))}
      </div>
    </div>
  );
}

